import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  CART_SYNC_START,
  CART_SYNC_SUCCESS,
  CART_SYNC_FAIL,
  FETCH_CART,
  ADD_CART_POSITION,
  PATCH_CART_POSITION,
  DELETE_CART_POSITION,
} from "@/reducers/shopping/cart/actions";

import * as cartApi from "@/api/cart";

function* fetchCart() {
  try {
    yield put({ type: CART_SYNC_START });
    const cart = yield call(cartApi.fetchCart);
    yield put({ type: CART_SYNC_SUCCESS, payload: cart });
  } catch (err) {
    yield put({ type: CART_SYNC_FAIL, payload: err, error: true });
  }
}

function* addCartPosition({ payload, meta }) {
  try {
    yield put({ type: CART_SYNC_START });
    const cart = yield call(cartApi.addCartPosition, payload);
    yield put({ type: CART_SYNC_SUCCESS, payload: cart, meta });
  } catch (err) {
    yield put({ type: CART_SYNC_FAIL, payload: err, error: true, meta });
  }
}

function* deleteCartPosition({ payload, meta }) {
  try {
    yield put({ type: CART_SYNC_START });
    const cart = yield call(cartApi.deleteCartPosition, payload);
    yield put({ type: CART_SYNC_SUCCESS, payload: cart, meta });
  } catch (err) {
    yield put({ type: CART_SYNC_FAIL, payload: err, error: true, meta });
  }
}

function* patchCartPosition({ payload, meta }) {
  try {
    yield put({ type: CART_SYNC_START });
    const { id, ...patch } = payload;
    const cart = yield call(cartApi.patchCartPosition, id, patch);
    yield put({ type: CART_SYNC_SUCCESS, payload: cart, meta });
  } catch (err) {
    yield put({ type: CART_SYNC_FAIL, payload: err, error: true, meta });
  }
}

export default function* cartSaga() {
  yield takeLatest(FETCH_CART, fetchCart);
  yield takeEvery(ADD_CART_POSITION, addCartPosition);
  yield takeEvery(PATCH_CART_POSITION, patchCartPosition);
  yield takeEvery(DELETE_CART_POSITION, deleteCartPosition);
}
